import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { Checkbox } from 'fronton-react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import React from 'react';
import { useRecoilState } from 'recoil';
import { CheckboxContainer } from './styles';

type TCheckboxComponent = {
  productId: string;
};

export const CheckboxComponent = ({ productId }: TCheckboxComponent) => {
  const [dimensionState, setDimensionState] = useRecoilState(dimensionsAtom);

  const isChecked =
    getIsCheckedProducts({ checkedProducts: dimensionState.checkedProducts, productId }) ?? false;

  const handleCheckboxChange = () => {
    setDimensionState(prevState => ({
      ...prevState,
      checkedProducts: prevState.checkedProducts.map(card =>
        card.id === productId ? { ...card, isChecked: !card.isChecked } : card
      ),
    }));
  };

  return (
    <CheckboxContainer>
      <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
    </CheckboxContainer>
  );
};
